import React from "react";
import LoadingSpinner from "../LoadingSpinner";

interface AppContentProps {
    customerSitesLoading: boolean;
    showOutlet: boolean;
    children: React.ReactNode;
}

export default function AppContent({ customerSitesLoading, showOutlet, children }: AppContentProps) {
    if (customerSitesLoading) {
        return <LoadingSpinner />;
    }

    if (showOutlet) {
        return <>{children}</>;
    }

    return <LoadingSpinner />;
}